export const TEAM_EDITOR_CONFIG = {
  inspection: {
    teamLabel: 'فريق المعاينة',
    vid: 'inspection_teams',
    tooltip: 'فريق المعاينة',
    placeholder: 'اختر أعضاء فريق المعاينة',
    showFormKey: 'showInspectionTeamsForm',
    currentTeamsKey: 'currentInspectionTeams',
    teamsKey: 'inspectionTeams',
    updatingKey: 'updatingInspectionTeams',
    loadingKey: 'loadingInspectionTeams',
    updateMethod: 'updateInspectionTeams',
    selectColSm: '12',
    selectColMd: '8',
  },
  gis: {
    teamLabel: 'فريق المكتب الفني',
    vid: 'gis_teams',
    tooltip: 'فريق المكتب الفني',
    placeholder: 'اختر أعضاء فريق المكتب الفني',
    showFormKey: 'showGisTeamsForm',
    currentTeamsKey: 'currentGisTeams',
    teamsKey: 'gisTeams',
    updatingKey: 'updatingGisTeams',
    loadingKey: 'loadingGisTeams',
    updateMethod: 'updateGisTeams',
    selectColSm: '8',
    selectColMd: '10',
  },
  geodesia: {
    teamLabel: 'فريق الجيوديسيا',
    vid: 'geodesia_teams',
    tooltip: 'فريق الجيوديسيا',
    placeholder: 'اختر أعضاء فريق الجيوديسيا',
    showFormKey: 'showGeodesiaTeamsForm',
    currentTeamsKey: 'currentGeodesiaTeams',
    teamsKey: 'geodesiaTeams',
    updatingKey: 'updatingGeodesiaTeams',
    loadingKey: 'loadingGeodesiaTeams',
    updateMethod: 'updateGeodesiaTeams',
    selectColSm: '8',
    selectColMd: '10',
  },
  drawing: {
    teamLabel: 'فريق الرسم',
    vid: 'drawing_teams',
    tooltip: 'فريق الرسم',
    placeholder: 'اختر أعضاء فريق الرسم',
    showFormKey: 'showDrawingTeamsForm',
    currentTeamsKey: 'currentDrawingTeams',
    teamsKey: 'drawingTeams',
    updatingKey: 'updatingDrawingTeams',
    loadingKey: 'loadingDrawingTeams',
    updateMethod: 'updateDrawingTeams',
    selectColSm: '8',
    selectColMd: '10',
  },
  uploadOnPlatform: {
    teamLabel: 'فريق الرفع على المنصة',
    vid: 'upload_on_platform_teams',
    tooltip: 'فريق الرفع على المنصة',
    placeholder: 'اختر أعضاء فريق الرفع على المنصة',
    showFormKey: 'showUploadOnPlatformTeamsForm',
    currentTeamsKey: 'currentUploadOnPlatformTeams',
    teamsKey: 'uploadOnPlatformTeams',
    updatingKey: 'updatingUploadOnPlatformTeams',
    loadingKey: 'loadingUploadOnPlatformTeams',
    updateMethod: 'updateUploadOnPlatformTeams',
    selectColSm: '8',
    selectColMd: '10',
  },
}
